/* unplugin-vue-components disabled */import { render } from "./PoolChangeWorker.vue?vue&type=template&id=087a7262"
import script from "./PoolChangeWorker.vue?vue&type=script&lang=js"
export * from "./PoolChangeWorker.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__